/*------------------*\
     MAIN SCRIPTS
\*------------------*/

// Ready
function ready(fn) {
  document.readyState !== "loading"
    ? fn()
    : document.addEventListener("DOMContentLoaded", fn);
}

// Check if invalid email (ignores empty values, which the required check already handles)
const isInvalidEmail = (email) =>
  !!email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

// Strip special characters
const stripSpecialChars = (string) =>
  string.replace(/[~"#%&*:;<>?\/\\{}|]/g, "");

// Handle Contact Form Submit
const handleContactFormSubmit = (event) => {
  event.preventDefault();

  // Form Config
  const form_config = {
    captcha_key: "6LeIYq4pAAAAAEKKw-zlkesQB5bKOK9N1iLByuT7",
    form_url: "https://submit-form.com/bYNYOKcbi",
    form_redirect_success: "/contact/success",
    form_redirect_error: "/contact/error",
  };

  // Form Error Messages
  const error_msgs = {
    required: "This field is required.",
    email: "Please enter a valid email address.",
  };

  // Form Elements
  const form = event.target;
  const form_submit = form.elements.submit;

  // Disable the Submit Button
  form_submit.textContent = "Sending…";
  form_submit.disabled = true;

  // Clear Existing Form Errors
  const current_form_errors = form.querySelectorAll(".form-error");
  if (current_form_errors && current_form_errors.length >= 1) {
    current_form_errors.forEach((error) => {
      error.remove();
    });
  }

  // Form Errors
  let form_errors = 0;

  // Insert Form Error
  const insertFormError = (form_element, msg) => {
    form_errors++;
    const p = document.createElement("p");
    p.classList.add("form-error");
    p.innerText = msg;
    form_element.insertAdjacentElement("afterend", p);
  };

  // Convert HTML Collection to Array
  const form_elements = form.elements;
  let form_elements_arr = [];
  [].forEach.call(form_elements, function (element) {
    if (element.type !== "submit") {
      form_elements_arr.push({
        id: element.id,
        type: element.type,
        value: element.value,
        required: element.required,
      });
    }
  });

  // Validate Form Elements
  let form_data = {};
  form_elements_arr.forEach((field) => {
    // Field Setup
    const field_input_element = document.getElementById(field.id);
    const field_input_value = field.value
      ? stripSpecialChars(field.value.trim())
      : undefined;

    // Required Field
    if (
      field.required === true &&
      (field_input_value === undefined || field_input_value === "")
    ) {
      insertFormError(field_input_element, error_msgs.required);
    }

    // Text Field
    if (field.type === "text" || field.type === "textarea") {
    }

    // Email Field
    if (field.type === "email") {
      // Is Invalid Email
      if (isInvalidEmail(field_input_value)) {
        insertFormError(field_input_element, error_msgs.email);
      }
    }

    // Add To Form Data
    form_data[field.id] = field_input_value;
  });

  if (form_errors === 0) {
    // Captcha Token
    grecaptcha.ready(function () {
      grecaptcha
        .execute(form_config.captcha_key, {
          action: "submit",
        })
        .then(async function (token) {
          // Add Captcha Token To Form Data
          form_data["g-recaptcha-response"] = token;

          // Submit Form
          await fetch(form_config.form_url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(form_data),
          })
            .then((response) => {
              if (response.ok === false) {
                window.location.href = form_config.form_redirect_error;
              } else {
                window.location.href = form_config.form_redirect_success;
              }

              // Reset Form
              form.reset();

              // Renable Submit Button
              form_submit.textContent = "Send Enquiry";
              form_submit.disabled = false;
            })
            .catch((error) => {
              // TODO: Log Error
              console.log(error);
            });
        });
    });
  }
};

// Init
const init = async () => {
  // Copyright Year
  const copyright_year = document.getElementById("copyrightYear");
  if (copyright_year) {
    const year = new Date().getFullYear();
    copyright_year.textContent = year;
  }

  // Code Highlighting
  const code_blocks = document.querySelector("code");
  if (code_blocks) {
    hljs.highlightAll();
  }

  // Contact Form Submit
  const form_contact = document.querySelector("#formContact");
  if (form_contact) {
    form_contact.addEventListener("submit", handleContactFormSubmit);
  }
};

// Initialise on Document Ready
ready(init);
